import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-arrow--down\"><path d=\"m9.532 14.787-5.45-5.45-.664.663L10 16.582 16.581 10l-.663-.662-5.449 5.45V3.417l-.937.001v11.368Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol